@if (featuredCollections?.length) {
  <mulo-centered-block-layout class="featured-collections" width="full">
    <h2 class="portal-section-title margin-bottom-md margin-top-md">
      {{ 'research.portal.featured.collections' | translate }}
    </h2>
    <mulo-horizontaller
      class="featured-tile-grid"
      [loading]="false"
      [buttonWidth]="media.is('lt-md') ? 32 : 72"
      [rtl]="i18nService.isLangRtl()"
      >
      @for (collection of featuredCollections; track collection) {
        <mulo-horizontaller-item [maxWidth]="576">
          <a
            mat-raised-button
            class="featured-tile-link has-shadow"
            color="default"
            [routerLink]="collection.permalink"
            [queryParams]="{ institution: institutionCode }"
            >
            <mulo-featured-tile
              [image]="collection.image"
              icon="bookmark-star"
              title="{{ 'research.collection.' + collection.code + '.name' | translate }}"
            ></mulo-featured-tile>
          </a>
        </mulo-horizontaller-item>
      }
    </mulo-horizontaller>
    <div class="featured-collections-c2a">
      <button
        routerLink="collections"
        mat-button
        color="primary"
        class="is-large has-icon has-icon-after"
        [queryParams]="{ institution: institutionCode }"
        >
        {{ 'research.portal.featured.collections.browse' | translate }}
        <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-right" muloSvgViewbox></mat-icon>
      </button>
    </div>
  </mulo-centered-block-layout>
}
